import {em} from './utils';

export {em};

export const promptFont = (ems: number) => `${em(ems)}px Prompt `;
